import React, {useState} from "react";
import {useDispatch} from "react-redux";
import axios from "axios";

import {httpRequestsOnSuccessActions, loadActions, LoadServices} from "store";
import {AddModalButton, CloseButton, modalsStyle, ValidationInput} from "components";
import { ErrorText, FindLoad, globalModals, useGlobalTextStyles } from 'utils';
import {LOAD_VERIFICATION} from "../../pages/accounting/constants";
import { receivablesTabEnums } from '../../pages/accounting/receivables/constants';

export const CorrectionsModal = ({handleClose, info, handleSetVerification, type, handleSend, handleChangeText, loadingCor, actionType, viewType}) =>{
    const globalModalsClasses = globalModals();
    const dispatch = useDispatch()
    const globalText = useGlobalTextStyles();
    const classes = modalsStyle();
    const [instruction, setInstruction] = useState('')
    const [error, setError] = useState('')
    const [loader, setLoader] = useState(loadingCor === true ? loadingCor : false)
    const loading = FindLoad(actionType);
    const handleChange = (e) =>{
        setInstruction(e.target.value)
        handleChangeText && handleChangeText(e.target.value)
        error && setError('')
    }

    const handleSendComment = () =>{
        if(instruction) {
            handleSend()
        }else{
            setError('instruction')
        }
    }

    const handleVerification = async ( ) =>{
        if(instruction) {
            setLoader(true)
            const data = {'correction' : instruction}
            try {
                // if(viewType === receivablesTabEnums.LOAD_GROUPS){
                //     await LoadServices.LoadToVerification(info.id, data, true)
                // }else{
                //     await LoadServices.LoadToVerification(info.id, data, true)
                // }
                await LoadServices.LoadToVerification(info.id, data, true)
                setLoader(false)
                handleSetVerification && handleSetVerification()
                handleClose()
                dispatch(httpRequestsOnSuccessActions.appendSuccess(LOAD_VERIFICATION))
                dispatch(loadActions.getLoadById(info.id, 'noLoad'))
            } catch (e) {
                setLoader(false)
            }
        }else{
            setError('instruction')
        }
    }

    return(
        <div>

            <div className={globalModalsClasses.smallModalWrapper}>
                <div className={globalModalsClasses.smallModalClose}>
                    <CloseButton handleCLic={handleClose}/>
                </div>
                <div className={globalModalsClasses.modalWrapperContent}>

                    <p className={globalText.modalTitle}>Corrections</p>
                    <p className={globalText.modalText}>Please, leave notes on corrections below.</p>

                    <ValidationInput
                        className={instruction ? classes.inputTextFieldBlue : classes.inputTextField}
                        variant={"outlined"}
                        name={"instruction"}
                        label={"Add Notes"}
                        type={'text'}
                        multiline={true}
                        Length={200}
                        typeError={error === 'instruction' && ErrorText.field}
                        onChange={handleChange}
                        value={instruction}
                    />
                    <AddModalButton
                        loading={loadingCor ? loadingCor : loading?.length ? !!loading?.length:  loader}
                        styles={{marginTop: '16px',}}
                        handleClick={type === 'notVerified' ? handleSendComment : handleVerification}
                        text={'Submit'}
                    />
                </div>
            </div>
        </div>
    )
}